'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactcss = require('reactcss');

var _reactcss2 = _interopRequireDefault(_reactcss);

var _createTemplateComponent = require('helpers/createTemplateComponent');

var _createTemplateComponent2 = _interopRequireDefault(_createTemplateComponent);

var _templateModeTypes = require('constants/templateModeTypes');

var _Email = require('components/common/Email');

var _props4 = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Email = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Email, _Component);

  function Email() {
    (0, _classCallCheck3.default)(this, Email);
    return (0, _possibleConstructorReturn3.default)(this, (Email.__proto__ || (0, _getPrototypeOf2.default)(Email)).apply(this, arguments));
  }

  (0, _createClass3.default)(Email, [{
    key: '_getStyle',
    value: function _getStyle() {
      var additionalProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _props = this.props,
          backgroundColor = _props.backgroundColor,
          padding = _props.padding,
          margin = _props.margin,
          borderStyle = _props.borderStyle,
          borderWidth = _props.borderWidth,
          borderColor = _props.borderColor;


      return (0, _reactcss2.default)({
        default: {
          container: {
            backgroundColor: backgroundColor,
            padding: padding,
            margin: margin,
            borderStyle: borderStyle,
            borderWidth: borderWidth,
            borderColor: borderColor
          }
        }
      }, (0, _extends3.default)({}, this.props, additionalProps));
    }
  }, {
    key: '_renderChildren',
    value: function _renderChildren() {
      var _props2 = this.props,
          childComponents = _props2.childComponents,
          id = _props2.id,
          direction = _props2.direction;


      if (!childComponents) return this.props.children || null;

      return childComponents.map(function (child, index) {
        var _child$xs = child.xs,
            xs = _child$xs === undefined ? 12 : _child$xs,
            _child$sm = child.sm,
            sm = _child$sm === undefined ? 12 : _child$sm,
            _child$md = child.md,
            md = _child$md === undefined ? 12 : _child$md,
            _child$lg = child.lg,
            lg = _child$lg === undefined ? 12 : _child$lg;

        xs = (xs / 12 * 100).toFixed(6) + '%';
        sm = (sm / 12 * 100).toFixed(6) + '%';
        md = (md / 12 * 100).toFixed(6) + '%';
        lg = (lg / 12 * 100).toFixed(6) + '%';

        var key = 'tq-plus-admin-container-email-' + id + '-child-' + index;
        var ChildComponent = (0, _createTemplateComponent2.default)(child, _templateModeTypes.EMAIL);

        if (!ChildComponent) return null;

        return direction === _props4.DIRECTIONS.HORIZONTAL ? _react2.default.createElement(
          _Email.TD,
          { key: key, style: { width: lg }, 'data-editor-id': child.id },
          _react2.default.createElement(ChildComponent, null)
        ) : _react2.default.createElement(
          _Email.TR,
          { key: key, 'data-editor-id': child.id },
          _react2.default.createElement(
            _Email.TD,
            null,
            _react2.default.createElement(ChildComponent, null)
          )
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          direction = _props3.direction,
          id = _props3.id;

      var style = this._getStyle();

      return _react2.default.createElement(
        _Email.Table,
        { width: '100%', style: style.container, 'data-editor-id': id },
        _react2.default.createElement(
          _Email.TBody,
          null,
          direction === _props4.DIRECTIONS.HORIZONTAL ? _react2.default.createElement(
            _Email.TR,
            null,
            this._renderChildren()
          ) : this._renderChildren()
        )
      );
    }
  }]);
  return Email;
}(_react.Component), _class.propTypes = _props4.propTypes, _class.defaultProps = _props4.defaultProps, _temp);
exports.default = Email;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Container/Email/Email.jsx
// module id = 1516
// module chunks = 0